import { call, put, takeEvery } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import {
	submissionCreateRequest,
	submissionCreateSuccess,
	submissionCreateFailure,
	submissionListRequest,
	submissionListSuccess,
	submissionListFailure,
	submissionCancelRequest,
	submissionCancelSuccess,
	submissionCancelFailure
} from '../actions'

import { waitForState, apiRequest } from 'utils'

function* requestCreateSubmission({ payload: { appId, handleClose } }) {
	try {
		const token = yield call(waitForState, state => state.user.token)

		const responseValidation = yield call(() => {
			return apiRequest(
				token,
				'/application/' + appId + '/performFullValidation',
				'post'
			)
		})

		if (responseValidation.status !== 202) {
			throw new Error(
				"Submission couldn't be created: " + responseValidation.error
			)
		}

		const responseSubmission = yield call(() => {
			return apiRequest(
				token,
				'/application/' + appId + '/submitToReview',
				'post'
			)
		})

		if (responseSubmission.status !== 202) {
			throw new Error(
				"Submission couldn't be created: " + responseSubmission.error
			)
		}
		const payload = yield {
			appId,
			receivedAt: Date.now()
		}
		yield put(submissionCreateSuccess(payload))
		yield call(() => delay(2000))
		yield put(submissionListRequest({ id: appId }))
	} catch (error) {
		yield put(submissionCreateFailure({ error }))
	}
}

function* requestCancelSubmission({ payload: { id, appId, handleClose } }) {
	try {
		const token = yield call(waitForState, state => state.user.token)
		const response = yield call(() => {
			return apiRequest(token, '/appSubmission/' + id + '/remove', 'post')
		})

		yield console.log(response)

		if (response.status === 202) {
			// yield call(() => handleClose())
			const payload = yield {
				id,
				appId,
				receivedAt: Date.now()
			}
			yield put(submissionCancelSuccess(payload))
			yield call(() => delay(2000))
			yield put(submissionListRequest({ id: appId }))
		} else {
			throw new Error("App submission couldn't be canceled")
		}
	} catch (error) {
		yield put(submissionCancelFailure({ error }))
	}
}

function* requestSubmissionList({ payload: { id } }) {
	try {
		// GET /developer/apps/:appPublicID/submissions
		const token = yield call(waitForState, state => state.user.token)
		const response = yield call(() => {
			return apiRequest(
				token,
				'/developer/apps/' + id + '/submissions',
				'get'
			)
		})

		if (response.status === 200) {
			const json = yield call(() => response.json())
			const payload = yield {
				items: {
					[id]: json.reduce((prev, next, i) => {
						prev[next.id] = next
						return prev
					}, {})
				},
				receivedAt: Date.now()
			}
			yield put(submissionListSuccess(payload))
		} else {
			throw new Error("App submissions list couldn't be loaded")
		}
	} catch (error) {
		yield put(submissionListFailure({ error }))
	}
}

export function* watchSubmissionRequests() {
	yield takeEvery(submissionCreateRequest, requestCreateSubmission)
	yield takeEvery(submissionCancelRequest, requestCancelSubmission)
	yield takeEvery(submissionListRequest, requestSubmissionList)
}



// WEBPACK FOOTER //
// ./src/sagas/submissions.js